document.addEventListener("DOMContentLoaded", function () {
  const faqContainer = document.querySelector(".contents_faq");

  if (!faqContainer) return;

  faqContainer.addEventListener("click", function (e) {
    const question = e.target.closest(".faq-question");

    if (!question) return;

    const item = question.closest(".faq-item");
    const items = faqContainer.querySelectorAll(".faq-item");
    const answer = item.querySelector(".faq-answer");
    const isOpen = item.classList.contains("active");

    items.forEach(function (el) {
      el.classList.remove("active");

      const ans = el.querySelector(".faq-answer");
      ans.style.maxHeight = null;
      ans.style.opacity = "0";
    });

    if (!isOpen) {
      item.classList.add("active");
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.style.opacity = "1";
    }
  });

  const firstActive = faqContainer.querySelector(".faq-item.active");

  if (firstActive) {
    const firstAnswer = firstActive.querySelector(".faq-answer");
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
    firstAnswer.style.opacity = "1";
  }
});